import mutations from './mutations.js'
import urlHelper from '@lib/utils/urlHelper'

export default {
  state: {
    visible: false,
    checkInDate: '',
    checkOutDate: '',
    onlyCanBooking: '',
    promotionId: urlHelper.queryString('id'),
    isLoading: true,
    cityId: ''
  },
  mutations
}
